import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-page-clean',
    templateUrl: './page-clean.component.html',
    styleUrls: ['./page-clean.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PageCleanComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
